import request from "@/utils/request";

// 角色列表
export const getRoulList = (data) => {
  return request({
    url: `/pushup-admin/admin/role/list`,
    method: "post",
    data
  });
};

// 新增角色
export const getAddRoul = (data) => {
  return request({
    url: `/pushup-admin/admin/role`,
    method: "post",
    data
  });
};
// 删除角色

export const getDeleteRoul = (id) => {
  return request({
    url: `/pushup-admin/admin/role/${id}`,
    method: "delete"
  });
};

// 修改角色
export const getUpdataRoul = (data) => {
  return request({
    url: `/pushup-admin/admin/role`,
    method: "put",
    data
  });
};
// 角色详情 
export const getInfoRoul = (id) => {
  return request({
    url: `/pushup-admin/admin/role/${id}`,
    method: "get"
  });
};
// 获取菜单
export const getMenuList = () => {
  return request({
    url: `/pushup-admin/admin/menu`,
    method: "get"
  });
};
